module.exports = "/fonts/fa-brands-400.woff?c4ed0a1f43bb44cf54014a03480b7177";